const calculate = (fuelConsumption: number, oilPrice: number): number => {
    return fuelConsumption * oilPrice;
  };
  
  export default calculate;
  